import React, { Ref } from 'react';
import './Carousel.scss';

interface CarouselProps {
  showMultiple: boolean;
  children: any;
  itemWidth?: number;
  height: string;
  showDots: boolean;
  disableDrag: boolean;
  clickHandle?: (
    childTarget: any,
    allChildren: [],
    currentItemIndex: number,
    orgEvent: any,
  ) => void;
  clickGuiNotify?: () => void;
  newItemNotify?: (index: number) => void;
  itemPadding?: number;
}
interface CarouselState {
  index: number;
  activeDrag: boolean;
  itemMax: number;
  intervalHandle: any;
  indexModify: number;
  indexMax: number;
  indexMin: number;
  itemVisible: number;
}

export default class Carousel extends React.Component<
  CarouselProps,
  CarouselState
> {
  viewFrameRef: Ref<HTMLDivElement>;
  constructor(prop: CarouselProps) {
    super(prop);

    let itemMax = 0;

    if (this.props.children != null) {
      itemMax = this.props.children.length;
    }

    this.state = {
      index: 0,
      activeDrag: false,
      itemMax: 0,
      intervalHandle: null,
      indexModify: 0,
      indexMin: 0,
      indexMax: itemMax,
      itemVisible: 1,
    };
    this.sliderRef = React.createRef();
    this.viewHelperRef = React.createRef();

    this.itemContainerRefsArray = [];

    if (this.props.itemPadding != undefined) {
      this.itemPadding = this.props.itemPadding;
    } else {
      this.itemPadding = 10;
    }

    this.viewFrameRef = React.createRef();
  }

  itemPadding;
  sliderRef;
  viewHelperRef;

  itemContainerRefsArray: any[];

  intervalHandler() {
    if (this.props.showMultiple) {
      let viewRef: any = this.viewFrameRef;
      if (viewRef.current != undefined) {
        let currentWith = viewRef.current.clientWidth;

        let itemVisible = Math.ceil(
          currentWith / (this.props.itemWidth + this.itemPadding),
        );
        if (this.state.itemVisible != itemVisible) {
          this.setState({ itemVisible: itemVisible });
        }
      }
    }
  }

  componentDidMount() {
    let intervalHandle = setInterval(() => {
      this.intervalHandler();
    }, 1000);

    let itemMax = 0;

    if (this.props.children?.length != undefined)
      itemMax = this.props.children.length - 1;

    this.setState({
      itemMax: itemMax,
      intervalHandle: intervalHandle,
    });
  }

  componentWillUnmount() {
    if (this.state.intervalHandle != null) {
      clearInterval(this.state.intervalHandle);
      this.setState({ intervalHandle: null });
    }
  }

  setMaxItem(max: number) {
    if (this.state.itemMax != max) this.setState({ itemMax: max });
  }

  startDrag(e) {
    e.target.draggable = false;
    /*
    let parentLink = e.target.parentElement;
    parentLink.setAttribute("_href", parentLink.href);
    parentLink.href = "javascript:void(0)";
    */
    if (e.type != 'touchstart') {
      document.startX = e.clientX;
      document.startY = e.clientY;
    } else {
      document.startX = e.targetTouches[0].screenX;
      document.startY = e.targetTouches[0].screenY;
    }

    document.dragItem = this;
    document.dragChild = e.target;
    document.onmousemove = this.mouseMove;
    document.ontouchmove = this.mouseMove;
    document.onmouseup = this.endDrag;
    document.ontouchend = this.endDrag;
    document.onmouseleave = this.endDrag;
    if (document.setCapture) document.setCapture();
    if (e.type != 'touchstart') e.preventDefault();
  }

  endDrag(e) {
    e.cancelBubble = true;
    e.preventDefault();

    let _this = document.dragItem;
    let xDelta = 0;
    let endX = 0;

    if (e.type == 'touchend') endX = e.changedTouches[0].screenX;
    else endX = e.clientX;

    xDelta = endX - document.startX;

    if (xDelta < 7 && xDelta > -7) {
      if (_this.props.clickHandle != undefined) {
        _this.props.clickHandle(
          document.dragChild,
          _this.props.children,
          _this.state.index,
          e,
        );
      } else {
        if (_this.props.clickGuiNotify != null) _this.props.clickGuiNotify();
      }
    } else {
      let newTrans = null;
      if (_this != null) {
        let itemWidth = 0;
        if (_this.props.showMultiple) {
          itemWidth = +_this.props.itemWidth + _this.itemPadding;
        } else {
          itemWidth = _this.viewHelperRef.current.clientWidth;
        }

        let itemDelta = xDelta / itemWidth;

        let itemDeltaComplet = itemDelta | 0;

        let itemPart = itemDelta - itemDeltaComplet;

        if (itemPart < -0.5) {
          itemDeltaComplet += -1;
        } else if (itemPart >= -0.5 && itemPart < 0.5) {
          itemDeltaComplet += 0;
        } else if (itemPart >= 0.5) {
          itemDeltaComplet += 1;
        }

        let newIndex = _this.state.index - itemDeltaComplet;

        if (newIndex < 0) {
          newIndex = _this.state.itemMax - 1 + newIndex;
        } else if (newIndex > _this.state.itemMax) {
          newIndex = newIndex - (_this.state.itemMax + 1);
        }

        if (_this.props.clickGuiNotify != null) _this.props.clickGuiNotify();

        _this.setNewItemIndex(newIndex);
      }
    }

    if (_this?.sliderRef?.current?.style != undefined)
      _this.sliderRef.current.style.transform =
        'translateX(' + _this.getTranslateX(0) + ')';

    document.onmousemove = null;
    document.ontouchmove = null;
    document.onmouseup = null;
    document.ontouchend = null;
    document.onmouseleave = null;
    document.dragItem = null;
    document.dragChild = null;

    return false;
  }
  mouseMove(e) {
    let xDelta = 0;
    if (e.type == 'touchmove')
      xDelta = e.targetTouches[0].screenX - document.startX;
    else xDelta = e.clientX - document.startX;
    let _this = document.dragItem;

    let translateX = _this.getTranslateX(xDelta);

    if (_this?.sliderRef?.current?.style != undefined)
      _this.sliderRef.current.style.transform =
        'translateX(' + translateX + ')';
  }

  getTranslateX(offset) {
    let currentIndex = this.state.index;

    let offsetX = 0;
    let itemWith = 0;

    if (this.props.showMultiple) {
      offsetX = offset;
    } else {
      if (offset != 0) {
        itemWith = this.viewHelperRef.current.clientWidth;
        offsetX = offset;
      }
    }

    let trans = '';
    if (this.props.showMultiple) {
      let itemIndex = currentIndex + this.state.indexModify;

      let itemWidth = +this.props.itemWidth;
      let itemPadding = this.itemPadding;
      let itemPaddingHalf = itemPadding / 2;

      trans =
        (itemWidth + itemPadding) * itemIndex * -1 -
        itemPaddingHalf +
        offsetX +
        'px';
    } else {
      if (offsetX == 0) trans = currentIndex * -100 + '%';
      else {
        trans = itemWith * currentIndex * -1 + offsetX + 'px';
      }
    }
    return trans;
  }

  componentDidUpdate(
    prevProps: CarouselProps,
    prevState: CarouselState,
    snapshot,
  ) {
    if (
      this.state.index != prevState.index ||
      this.state.itemVisible != prevState.itemVisible
    )
      this.prepareUnvisible(0);
  }

  prepareUnvisible(moveIndex: number) {
    let index = this.state.index + moveIndex;
    let visibleItems = this.state.itemVisible;
    let maxItem = this.props.children.length;

    let oldModi = this.state.indexModify;

    let paddingsItems = Math.ceil((maxItem - visibleItems) / 2);

    if (!(paddingsItems > 0)) {
      paddingsItems = 0;
    }

    let newModi = paddingsItems + index;

    let oldIndexMax = this.state.indexMax;
    let newIndexMax = index + visibleItems + newModi;

    let oldMinIndex = this.state.indexMin;
    let newMinIndex = newModi;

    if (index + visibleItems > maxItem) {
      newModi = 0;
      newIndexMax = index + visibleItems + newModi;
      newMinIndex = index - Math.ceil((maxItem - visibleItems) / 2);
    }

    if (
      oldModi != newModi ||
      oldIndexMax != newIndexMax ||
      oldMinIndex != newMinIndex
    ) {
      //debugger;
      /*
      console.log({
        oldModi: oldModi,
        newModi: newModi,
        oldIndexMax: oldIndexMax,
        newIndexMax: newIndexMax,
        oldMinIndex: oldMinIndex,
        newMinIndex: newMinIndex,
      });
      */
      this.setState({
        indexModify: newModi,
        indexMax: newIndexMax,
        indexMin: newMinIndex,
      });
    }
  }

  render() {
    let height = this.props.height;

    let translatte = 'translateX(' + this.getTranslateX(0) + ')';

    let drag = {};

    if (!this.props.disableDrag) {
      drag = {
        onMouseDown: (e) => this.startDrag(e),
        onTouchStart: (e) => this.startDrag(e),
      };
    }
    let currentIndex = this.state.index;

    return (
      <div className="carousel mainFrame">
        <div className="carousel viewFrame" ref={this.viewFrameRef}>
          <div
            className="carousel viewFrameHelper"
            style={{
              height: height,
            }}
            ref={this.viewHelperRef}
            {...drag}
          >
            <div
              style={{
                transform: translatte,
              }}
              draggable={!this.props.disableDrag}
              className="carousel slider"
              ref={this.sliderRef}
            >
              {this.props.children != undefined
                ? this.props.children.map((item, index) => {
                    let dynamicProps = {};

                    let leftPos = '';
                    if (this.props.showMultiple) {
                      let itemIndex = index + this.state.indexModify;
                      let visibleItems = this.state.itemVisible;

                      let maxIndex = this.state.indexMax;
                      let minIndex = this.state.indexMin;

                      if (itemIndex > maxIndex) {
                        itemIndex =
                          index -
                          (this.props.children.length - this.state.indexModify);
                      } else if (itemIndex < minIndex) {
                        itemIndex =
                          index +
                          this.props.children.length +
                          this.state.indexModify;
                      }

                      let itemWidth = +this.props.itemWidth;
                      let itemPadding = this.itemPadding;
                      let itemPaddingHalf = itemPadding / 2;

                      leftPos =
                        itemPaddingHalf +
                        (itemWidth + itemPadding) * itemIndex +
                        'px';
                    } else leftPos = index * 100 + '%';

                    dynamicProps.style = {
                      left: leftPos,
                      height: this.props.height,
                    };

                    if (!this.props.showMultiple)
                      dynamicProps.style.width = '100%';
                    else dynamicProps.style.width = this.props.itemWidth + 'px';

                    let className = 'carouselItem';
                    if (index == this.state.index) className += ' selected';
                    return (
                      <div
                        key={'carouselItem' + index}
                        ref={(itemRef) => this.setRefIem(index, itemRef)}
                        className={className}
                        {...dynamicProps}
                      >
                        {item}
                      </div>
                    );
                  })
                : null}
            </div>
          </div>
        </div>
        <button
          className="prev-next-button previous"
          onClick={(e) => {
            if (this.props.clickGuiNotify != null) this.props.clickGuiNotify();
            let newIndex = -1;
            if (this.state.index > 0) newIndex = this.state.index - 1;
            else newIndex = this.state.itemMax;

            this.setNewItemIndex(newIndex);
            e.preventDefault();
          }}
        />
        <button
          className="prev-next-button next"
          onClick={(e) => {
            if (this.props.clickGuiNotify != null) this.props.clickGuiNotify();
            let newIndex = -1;

            if (this.state.index < this.state.itemMax)
              newIndex = this.state.index + 1;
            else newIndex = 0;

            this.setNewItemIndex(newIndex);
            e.preventDefault();
          }}
        />
        {this.props.showDots ? (
          <ol className="dots">
            {this.props.children.map((item, index) => {
              if (index < this.state.itemMax + 1) {
                let className = 'dot';
                if (index == this.state.index) className += ' selected';
                return (
                  <li
                    key={'carouselDot' + index}
                    data-index={index}
                    className={className}
                    onClick={(e) => {
                      if (this.props.clickGuiNotify != null)
                        this.props.clickGuiNotify();
                      let newIndex = +e.target.getAttribute('data-index');
                      this.setNewItemIndex(newIndex);
                    }}
                  ></li>
                );
              }
            })}
          </ol>
        ) : null}
      </div>
    );
  }

  setNewItemIndex(newIndex: number) {
    if (this.state.index != newIndex) {
      if (this.props.newItemNotify != null) this.props.newItemNotify(newIndex);
      this.setState({ index: newIndex });
    }
  }

  setRefIem(itemIndex: number, item: any) {
    if (item != null) {
      if (this.itemContainerRefsArray.length < itemIndex + 1) {
        this.itemContainerRefsArray.push(item);
      } else {
        this.itemContainerRefsArray[itemIndex] = item;
      }
    }
  }
}
